import { FieldItemAppearance } from './draggable-field.styles';

interface GetDragabbleFieldAppearancePayload {
  isAlreadyUsed: boolean;
  isSyncable: boolean;
  isEmpty: boolean;
}

export function getDragabbleFieldAppearance({
  isAlreadyUsed,
  isSyncable,
  isEmpty,
}: GetDragabbleFieldAppearancePayload): FieldItemAppearance {
  if (isAlreadyUsed) {
    return 'disabled';
  }

  if (isEmpty) {
    return 'empty';
  }

  if (!isSyncable) {
    return 'subdued';
  }

  return 'default';
}
